var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns is-multiline" }, [
    _c(
      "section",
      { staticClass: "column is-full uxo-uxo-types px-0" },
      [
        !_vm.fetchingUxoTypes
          ? [
              _vm._l(_vm.uxoTypes, function(uxoType) {
                return [
                  uxoType.slug !== "not-set"
                    ? _c("div", { staticClass: "mb-7" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "columns d-flex align-items-center justify-content-between mb-1"
                          },
                          [
                            _c("div", { staticClass: "column" }, [
                              _c("h2", { staticClass: "h1" }, [
                                _vm._v(_vm._s(uxoType.name))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column text-right" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "underline-link underline-navy font-weight-bold",
                                  attrs: {
                                    href: "/explosive-hazards/" + uxoType.slug
                                  }
                                },
                                [_vm._v("View All")]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "uxo-list columns is-multiline is-mobile mb-5"
                          },
                          [
                            _vm._l(uxoType.hazards, function(hazard) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "column is-4-mobile is-2-tablet"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "uxo-list__item",
                                        attrs: {
                                          href: _vm.hazardUrl(
                                            uxoType.slug,
                                            hazard.slug
                                          )
                                        }
                                      },
                                      [
                                        hazard.images
                                          ? _c("img", {
                                              staticClass: "image mb-1",
                                              attrs: {
                                                src: hazard.images[0].aws_url,
                                                alt: hazard.name
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          { staticClass: "font-weight-normal" },
                                          [_vm._v(_vm._s(hazard.name))]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ]
              })
            ]
          : [
              _c(
                "div",
                { staticClass: "content-loader" },
                [
                  _c(
                    "ContentLoader",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        height: 56,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "460",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "56"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 240,
                        width: 720,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "16",
                          y: "156",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "176",
                          y: "155",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "336",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "492",
                          y: "154",
                          rx: "0",
                          ry: "0",
                          width: "140",
                          height: "24"
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c90ffa7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c90ffa7a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/UxoTypes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c90ffa7a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/UxoTypes.vue
// module chunks = 0 1